import store from '~/store'

export default async (to, from, next) => {
  if (!store.getters['auth/check'] && store.getters['auth/token']) {
    try {
      await store.dispatch('auth/fetchUser')
      if(to.name === 'login'){
        return  next({name:'home'})
      }
    } catch (e) { }
  }  

  next()
}